import { UserSkillDto } from "@/common/models/skills";
import { DesireType } from "@/components/molecules/desire";
import { CheckedState } from "@/components/molecules/multiCheckbox";
import { PresenceDto, SupervisedQueue } from "@/repository/models";

export class SupervisorAgentDto {
	id!: string;
	name!: string;
	upn!: string;
	reason!: string;
	presence!: PresenceDto;
	lastHandled?: Date;
	hasClient!: boolean;
	skills?: UserSkillDto[];
	queues?: SupervisedQueue[];
	workload!: number;
	isSupervisorOnAtLeastOneQueue!: boolean;
	isAiAgent!: boolean;
}

export enum SupervisorTableColumnNames {
	Agent = "Agent",
	Skills = "Skills",
	LastHandled = "LastHandled",
	Workload = "Workload",
	StatusTimer = "StatusTimer",
	Reason = "Reason",
	HasClient = "HasClient",
	JoinedTo = "JoinedTo",
	Desire = "DesireHeader",
}

export interface AgentMemberUpdatedDto {
	deleted: string[];
	updated: AgentUpdatedData[];
	queueId: string;
}

export interface AgentUpdatedData {
	Id: string;
	IsJoined: boolean;
	Desire: number;
}

export interface AgentJoinedToProps {
	id: string;
	queues: SupervisedQueue[];
	onJoinChange: (data: SupervisedQueue, checked: CheckedState) => void;
	onDesireChange: (data: SupervisedQueue, desire: DesireType) => void;
	onJoinAllChange: (agentId: string, checked: CheckedState) => void;
}

export interface SupervisorListMobileProps {
    supervisorTableItems: SupervisorAgentDto[];
    supervisorShowStatusTimer: boolean;
    getHasClientStatusIcon: (hasClient: boolean) => JSX.Element;
    getJoinedToMultipleQueuesCellContent: (
        agent: SupervisorAgentDto
    ) => JSX.Element;
    workloadMenu: (item: SupervisorAgentDto) => JSX.Element;
    agentTimer: (item: SupervisorAgentDto) => "" | JSX.Element;
}